"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

var _default = /*#__PURE__*/_react["default"].memo(function Error(_ref) {
  var _error$message;

  var error = _ref.error;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isShow = _React$useState2[0],
      setShow = _React$useState2[1];

  var messageClassName = _react["default"].useMemo(function () {
    return (0, _classnames["default"])(_defaultModule["default"]['message'], (0, _defineProperty2["default"])({}, _defaultModule["default"]['is-show'], isShow));
  }, [isShow]);

  function handleOpenMessage() {
    setShow(!isShow);
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['wrapper']
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['info']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _defaultModule["default"]['title']
  }, "\u041E\u0448\u0438\u0431\u043A\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0434\u0430\u043D\u043D\u044B\u0445"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _defaultModule["default"]['error']
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-info'),
    onClick: handleOpenMessage
  }))), isShow && /*#__PURE__*/_react["default"].createElement("div", {
    className: messageClassName
  }, (_error$message = error === null || error === void 0 ? void 0 : error['message']) !== null && _error$message !== void 0 ? _error$message : 'Нет данных', (error === null || error === void 0 ? void 0 : error['stack']) && /*#__PURE__*/_react["default"].createElement("pre", {
    className: _defaultModule["default"]['stack']
  }, error['stack'])));
});

exports["default"] = _default;